<template>
    <div ref="captchaContainer" />
</template>

<script lang="ts" setup>
const captchaContainer = useTemplateRef<HTMLElement>('captchaContainer');
const { $recaptchaSiteKey } = useNuxtApp();

onMounted(async () => {
    await nextTick();
    if (window.grecaptcha && captchaContainer.value) {
        window.grecaptcha.render(captchaContainer.value, {
            sitekey: $recaptchaSiteKey,
        });
    }
});
</script>
